module.exports = __webpack_public_path__ + "img/fresh.c5d79d25.svg";